import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Navigate, Outlet } from "react-router-dom";
import Forbidden from "../Screen/forbidden";

const ProtectedRoutes = ({permission}) => {

  const userVerificationCandidateStore = useSelector((state) => state.user);
  const { userData } = userVerificationCandidateStore;

  let status = 0;
  if(userData){
    status = 1
  }else{
    status = 0;
  }

  console.log(status);
  console.log(permission);

  //logic to check if user token is valid then only proceed with protected routes
  const isAuthenticated = status && permission ;
  console.log(isAuthenticated);
  return isAuthenticated ? <Outlet /> : <Forbidden />;

};

export default ProtectedRoutes;
